import classNames from 'classnames';
import { ArrowDownAzIcon, ArrowUpAzIcon, ArrowUpDownIcon } from 'lucide-react';
import { PropsWithChildren } from 'react';

interface SpinnerProps extends PropsWithChildren {
  id: string;
  sortField: string;
  sortDirection: number;
  updateSortOrder: (newId: string, newDirection: number) => void;
}

function TableHeaderSortable({
  id,
  sortField,
  sortDirection,
  updateSortOrder,
  children,
}: SpinnerProps) {
  return (
    <div
      role="button"
      className="flex flex-row items-center"
      onClick={(event) => {
        event.preventDefault();
        if (sortField === id) {
          updateSortOrder(id, sortDirection * -1);
        } else {
          updateSortOrder(id, 1);
        }
      }}
    >
      <span className={classNames('m-1', sortField === id ? '' : 'text-neutral-400')}>
        {sortField === id ? (
          sortDirection > 0 ? (
            <ArrowDownAzIcon size={20} />
          ) : (
            <ArrowUpAzIcon size={20} />
          )
        ) : (
          <ArrowUpDownIcon size={20} />
        )}
      </span>
      {children}
    </div>
  );
}

export default TableHeaderSortable;
